import React from 'react';
import { Col, Row, Button } from 'antd';
import styles from './index.less';
import GeneralLayout from '../../layouts/general';
import { localeSelector } from '../../selector/app';
import { useSelector } from 'react-redux';
import { CommonSectionLayout, ChowbusoneComposedTags, OurClients } from 'src/components/POSWebsite/legacy';
import { FormattedMessage, useIntl } from 'react-intl';
import ScheduleYourFreeDemo from '../../components/ScheduleYourFreeDemo';
import { JoinClassName } from 'src/utils/utils';
import POSProductFeatures from '../../components/POSProductFeatures';
import FrozenRatio from '../../components/FrozenRatio/FrozenRatio';
import useLocale from 'src/hooks/useLocale';
import UnoptimizedImage from 'src/components/UnoptimizedImage';
import useSEOMeta from 'src/hooks/useSEOMetaHook';
import OurCustomerBrandWall from 'src/components/POSWebsite/OurCustomerBrandWall';

const PricingPromotion = {
  en: [
    {
      isPromotion: false,
      includeBasicPackage: false,
      title: `Chowbus POS
      Starter Package`,
      pricing: '',
      pricingSuffix: '/month',
      features: [
        {
          title: 'Cloud-based Point of Sale',
          points: [
            {
              desc: 'Order & Table Management',
            },
            {
              desc: 'Reporting & Analytics',
            },
            {
              desc: 'Menu & Team Management',
            },
            {
              desc: 'Payment Processing',
            },
            {
              desc: 'Multi-location Management',
            },
            {
              desc: 'Offline Mode',
            },
          ],
        },
        {
          title: 'Customer Support',
          points: [
            {
              desc: '24/7 Customer Service',
            },
            {
              desc: 'Installation & Network Configuration',
            },
            {
              desc: 'Automatic Feature & Software Upgrades',
            },
            {
              desc: 'Digital & Physical Gift Cards*',
            },
          ],
        },
        {
          title: 'Save Labor w. Smart Ordering',
          points: [
            {
              desc: 'QR Code Ordering',
            },
            {
              desc: 'Tablet Ordering',
            },
            {
              desc: 'Kiosk Ordering',
            },
            {
              desc: 'Weight Scale',
            },
          ],
        },
        {
          title: 'Loyalty & CRM Solution',
          points: [
            {
              desc: 'Restaurant Loyalty Program',
            },

            {
              desc: 'CRM (MMS & SMS) ',
            },
          ],
        },
        {
          title: 'Growth Solution',
          points: [
            {
              desc: 'Online Ordering',
            },
            {
              desc: 'Website Design',
            },
          ],
        },
      ],
    },
    {
      isPromotion: false,
      includeBasicPackage: false,
      title: `Chowbus POS 
      Efficiency Package`,
      pricing: '',
      pricingSuffix: '/month',
      features: [
        {
          title: 'Cloud-based Point of Sale',
          points: [
            {
              desc: 'Order & Table Management',
            },
            {
              desc: 'Reporting & Analytics',
            },
            {
              desc: 'Menu & Team Management',
            },
            {
              desc: 'Payment Processing',
            },
            {
              desc: 'Multi-location Management',
            },
            {
              desc: 'Offline Mode',
            },
          ],
        },
        {
          title: 'Customer Support',
          points: [
            {
              desc: '24/7 Customer Service',
            },
            {
              desc: 'Installation & Network Configuration',
            },
            {
              desc: 'Automatic Feature & Software Upgrades',
            },
            {
              desc: 'Digital & Physical Gift Cards*',
            },
          ],
        },
        {
          title: 'Save Labor w. Smart Ordering',
          points: [
            {
              desc: 'QR Code Ordering',
            },
            {
              desc: 'Tablet Ordering',
            },
            {
              desc: 'Kiosk Ordering',
            },
            {
              desc: 'Weight Scale',
            },
            {
              desc: 'Waitlist & Reservation',
            },
            {
              desc: '3rd Party Delivery Integration',
            },
          ],
        },
        {
          title: 'Loyalty & CRM Solution',
          points: [
            {
              desc: 'Restaurant Loyalty Program',
            },
            {
              desc: 'CRM (MMS & SMS) ',
            },
          ],
        },
        {
          title: 'Growth Solution',
          points: [
            {
              desc: 'Online Ordering',
            },
            {
              desc: 'Website Design',
            },
            {
              desc: 'Promotion Engine',
            },
          ],
        },
      ],
    },
    {
      isPromotion: true,
      includeBasicPackage: false,
      title: `Chowbus POS
      Growth Package`,
      pricing: '',
      pricingSuffix: '/month',
      features: [
        {
          title: 'Cloud-based Point of Sale',
          points: [
            {
              desc: 'Order & Table Management',
            },
            {
              desc: 'Reporting & Analytics',
            },
            {
              desc: 'Menu & Team Management',
            },
            {
              desc: 'Payment Processing',
            },
            {
              desc: 'Multi-location Management',
            },
            {
              desc: 'Offline Mode',
            },
            {
              desc: 'Multi-location Transaction System',
            },
          ],
        },
        {
          title: 'Customer Support',
          points: [
            {
              desc: '24/7 Customer Service',
            },
            {
              desc: 'Installation & Network Configuration',
            },
            {
              desc: 'Automatic Feature & Software Upgrades',
            },
            {
              desc: 'Digital & Physical Gift Cards*',
            },
          ],
        },
        {
          title: 'Save Labor w. Smart Ordering',
          points: [
            {
              desc: 'QR Code Ordering',
            },
            {
              desc: 'Tablet Ordering',
            },
            {
              desc: 'Kiosk Ordering',
            },
            {
              desc: 'Weight Scale',
            },
            {
              desc: 'Waitlist & Reservation',
            },
            {
              desc: '3rd Party Delivery Integration',
            },
          ],
        },
        {
          title: 'Loyalty & CRM Solution',
          points: [
            {
              desc: 'Restaurant Loyalty Program',
            },
            {
              desc: 'CRM (MMS & SMS) ',
            },
            {
              desc: 'Multi-location Loyalty System',
            },
          ],
        },
        {
          title: 'Growth Solution',
          points: [
            {
              desc: 'Online Ordering',
            },
            {
              desc: 'Website Design',
            },
            {
              desc: 'Promotion Engine',
            },
          ],
        },
      ],
    },
  ],
  zh: [
    {
      isPromotion: false,
      includeBasicPackage: false,
      title: `Chowbus POS 
        入门套餐`,
      pricing: '',
      pricingSuffix: '/月',
      features: [
        {
          title: '云端餐饮管理系统',
          points: [
            {
              desc: '订单管理 & 桌位管理',
            },
            {
              desc: '报表系统 & 专业分析',
            },
            {
              desc: '菜单管理 & 团队管理',
            },
            {
              desc: '支付收单',
            },
            {
              desc: '多店报表 & 管理系统',
            },
            {
              desc: '离线模式',
            },
          ],
        },
        {
          title: '售后客服',
          points: [
            {
              desc: '全天候客服',
            },
            {
              desc: '到店安装 & 连接网络',
            },
            {
              desc: '功能 & 软件自动升级',
            },
            {
              desc: '电子 & 实体礼卡',
            },
          ],
        },
        {
          title: '智能点餐系统,帮您节省人工',
          points: [
            {
              desc: '扫码点餐',
            },
            {
              desc: '平板自助点餐',
            },
            {
              desc: '智能点餐机自助点餐',
            },
            {
              desc: '电子秤',
            },
          ],
        },
        {
          title: '会员系统 & 客户关系管理解决方案',
          points: [
            {
              desc: '餐厅专属会员系统',
            },
            {
              desc: '会员短信营销（彩信 & 短信）',
            },
          ],
        },
        {
          title: '增收解决方案',
          points: [
            {
              desc: '网页点餐',
            },
            {
              desc: '餐厅网站设计制作',
            },
          ],
        },
      ],
    },
    {
      isPromotion: false,
      includeBasicPackage: false,
      title: `Chowbus POS 
      增效套餐`,
      pricing: '',
      pricingSuffix: '/月',
      features: [
        {
          title: '云端餐饮管理系统',
          points: [
            {
              desc: '订单管理 & 桌位管理',
            },
            {
              desc: '报表系统 & 专业分析',
            },
            {
              desc: '菜单管理 & 团队管理',
            },
            {
              desc: '支付收单',
            },
            {
              desc: '多店报表 & 管理系统',
            },
            {
              desc: '离线模式',
            },
          ],
        },

        {
          title: '售后客服',
          points: [
            {
              desc: '全天候客服',
            },
            {
              desc: '到店安装 & 连接网络',
            },
            {
              desc: '功能 & 软件自动升级',
            },
            {
              desc: '电子 & 实体礼卡',
            },
          ],
        },
        {
          title: '智能点餐系统,帮您节省人工',
          points: [
            {
              desc: '扫码点餐',
            },
            {
              desc: '平板自助点餐',
            },
            {
              desc: '智能点餐机自助点餐',
            },
            {
              desc: '电子秤',
            },
            {
              desc: '等位 & 预约',
            },
            {
              desc: '第三方外卖平台整合',
            },
          ],
        },
        {
          title: '会员系统 & 客户关系管理解决方案',
          points: [
            {
              desc: '餐厅专属会员系统',
            },
            {
              desc: '会员短信营销（彩信 & 短信）',
            },
          ],
        },
        {
          title: '增收解决方案',
          points: [
            {
              desc: '网页点餐',
            },
            {
              desc: '餐厅网站设计制作',
            },
            {
              desc: '促销引擎',
            },
          ],
        },
      ],
    },

    {
      isPromotion: true,
      includeBasicPackage: false,
      title: `Chowbus POS 
      增收套餐`,
      pricing: '',
      pricingSuffix: '/月',
      features: [
        {
          title: '云端餐饮管理系统',
          points: [
            {
              desc: '订单管理 & 桌位管理',
            },
            {
              desc: '报表系统 & 专业分析',
            },
            {
              desc: '菜单管理 & 团队管理',
            },
            {
              desc: '支付收单',
            },
            {
              desc: '多店报表 & 管理系统',
            },
            {
              desc: '离线模式',
            },
            {
              desc: '跨店交易&结算系统',
            },
          ],
        },
        {
          title: '售后客服',
          points: [
            {
              desc: '全天候客服',
            },
            {
              desc: '到店安装 & 连接网络',
            },
            {
              desc: '功能 & 软件自动升级',
            },
            {
              desc: '电子 & 实体礼卡',
            },
          ],
        },
        {
          title: '智能点餐系统,帮您节省人工',
          points: [
            {
              desc: '扫码点餐',
            },
            {
              desc: '平板自助点餐',
            },
            {
              desc: '智能点餐机自助点餐',
            },
            {
              desc: '电子秤',
            },
            {
              desc: '等位 & 预约',
            },
            {
              desc: '第三方外卖平台整合',
            },
          ],
        },
        {
          title: '会员系统 & 客户关系管理解决方案',
          points: [
            {
              desc: '餐厅专属会员系统',
            },
            {
              desc: '会员短信营销（彩信 & 短信）',
            },
            {
              desc: '集团跨店会员',
            },
          ],
        },
        {
          title: '增收解决方案',
          points: [
            {
              desc: '网页点餐',
            },
            {
              desc: '餐厅网站设计制作',
            },
            {
              desc: '促销引擎',
            },
          ],
        },
      ],
    },
  ],
};

const PricingTopSection = {
  en: {
    title: 'Every restaurant should succeed',
    description: 'Chowbus POS, designed to build the most comprehensive ecosystem to empower restaurants ',
    promotionDesc: 'Complete POS hardware equipments, original price $3,118, now available for FREE!',
  },
  zh: {
    title: '每个餐厅都能够成功',
    description: 'Chowbus POS旨在构建最全面的生态系统，为餐厅提供支持',
    promotionDesc: '全套餐厅POS硬件设备，原价$3,118，现在免费！',
  },
};

const Feature = {
  en: {
    title: `Rated the BEST POS for Restaurants`,
    subTitle: `The next generation all-in-one POS that can save you more than $8,000/mo. in labor costs and grow your business 25%. 
    Running Your Restaurant Has Never Been Easier

Get all the tools you need to make it easier to run your restaurant.`,
    featureList: [
      {
        image: `${process.env.ASSETS_PREFIX}/pricing_feature_01.png`,
        imageAlt: 'Save Labor with Smart Ordering',
        title: 'Save Labor with Smart Ordering',
        description: `Kiosk
        Tablet Ordering
        QR Code Ordering
        Waitlist`,
      },
      {
        image: `${process.env.ASSETS_PREFIX}/pricing_feature_02.png`,
        imageAlt: 'Grow & Retain Loyal Customers',
        title: 'Grow & Retain Loyal Customers',
        description: `Restaurant Loyalty Program
        Restaurant CRM Marketing
        Restaurant Digital & Physical Gift Cards`,
      },
      {
        image: `${process.env.ASSETS_PREFIX}/pricing_feature_03.png`,
        imageAlt: 'Grow Your Business',
        title: 'Grow Your Business',
        description: `Online Ordering
        Chowbus Delivery Services
        Chowbus Marketplace Integration
        Third Party Delivery Integrations`,
      },
    ],
  },
  zh: {
    title: `评为餐厅的最佳POS系统`,
    subTitle: `下一代全能POS系统，可以为您每月节省超过$8,000的人工成本，
    同时增长至少25%营业额 

    获取您所需的所有产品，使经营餐厅更轻松！`,
    featureList: [
      {
        image: `${process.env.ASSETS_PREFIX} /pricing_feature_01.png`,
        imageAlt: '使用智能点餐系统节省人力',
        title: '使用智能点餐系统节省人力',
        description: `智能自助点餐机
        平板点餐
        二维码点餐
        等位系统`,
      },
      {
        image: `${process.env.ASSETS_PREFIX}/pricing_feature_02.png`,
        imageAlt: '增长并留存忠实顾客',
        title: '增长并留存忠实顾客',
        description: `餐厅专属会员系统
        餐厅客户关系营销
        餐厅电子会员+实体礼卡`,
      },
      {
        image: `${process.env.ASSETS_PREFIX}/pricing_feature_03.png`,
        imageAlt: '发展您的业务',
        title: '发展您的业务',
        description: `餐厅订餐网页
        Chowbus外送服务
        Chowbus外卖平台整合
        第三方外卖平台集成`,
      },
    ],
  },
};

const SuccessCase = {
  en: {
    title: `See how real restaurants grow their business 
    with Chowbus POS`,
    description: 'Running A Restaurant Should Be Simple',
    list: [
      {
        avator: `${process.env.ASSETS_PREFIX}/pricing_case_avator_01.png`,
        alt: 'Machi Machi',
        desc: `“We use Chowbus POS and love their Restaurant Loyalty Program. Our loyal members spend up to 18% more than other customers. When new customers come to the store, they can directly order from the Chowbus Kiosk, and the system will encourage them to sign up for the restaurant loyalty program through the unique QR code. Later, we can send customers a promotion by SMS to get them back into our store again.`,
        restaurantName: `Machi Machi`,
        restaurantLocation: ' New York, NY',
      },
      {
        avator: `${process.env.ASSETS_PREFIX}/pricing_case_avator_02.png`,
        alt: 'KAJIKEN',
        desc: `"We increased the average order size by 3x with Chowbus POS & Tablet Ordering. Guests can browse the appealing menu at their own pace. No need for the server to wait and type in orders anymore. The appealing product visual and description make it clear what the guests are ordering. This makes customers eyes ogle with every second when they scroll through the menu."`,
        restaurantName: `KAJIKEN`,
        restaurantLocation: 'Baltimore, MD',
      },
      {
        avator: `${process.env.ASSETS_PREFIX}/pricing_case_avator_03.png`,
        alt: 'Machi Machi',
        desc: `"Chowbus Online Ordering helped increase our revenue by 20%. Online Ordering allows customers to order takeout and delivery directly from our own website. By leveraging Chowbus POS to reduce the amount of time our staff dedicates to manual tasks, and then keep customers coming back through the loyalty program. Most importantly, there are no third-party fees, our website become the most profitable order source."`,
        restaurantName: `Mrs Gu Skewers Hot Pot`,
        restaurantLocation: 'Chicago, IL',
      },
    ],
  },
  zh: {
    title: `看看真实的餐厅如何通过
    Chowbus POS推动业务增长`,
    description: '经营餐厅应该是简单的',
    list: [
      {
        avator: `${process.env.ASSETS_PREFIX}/pricing_case_avator_01.png`,
        alt: 'Machi Machi',
        desc: `我们非常喜欢Chowbus POS的餐厅专属会员系统。我们的忠实会员比其他顾客多消费高达18%。当新顾客来到店里时，他们可以直接从Chowbus自助点餐机上点餐，系统会通过独特的二维码鼓励他们加入餐厅专属会员。之后，我们可以通过短信向顾客发送促销信息，让他们再次光顾我们的门店。`,
        restaurantName: `Machi Machi`,
        restaurantLocation: '纽约',
      },
      {
        avator: `${process.env.ASSETS_PREFIX}/pricing_case_avator_02.png`,
        alt: 'KAJIKEN',
        desc: `我们使用了Chowbus POS系统和平板点餐，平均订单金额增加了3倍。客人可以自行浏览吸引人的菜单界面，不再需要服务员等待和手动输入订单。高清的产品图片和描述清晰地展示了客人所点的菜品，让客人在浏览菜单时目不转睛。`,
        restaurantName: `KAJIKEN`,
        restaurantLocation: '巴尔的摩',
      },
      {
        avator: `${process.env.ASSETS_PREFIX}/pricing_case_avator_03.png`,
        alt: 'Machi Machi',
        desc: `Chowbus餐厅订单网页帮助我们的营收增加了20%.。餐厅订单网页使顾客可以直接从我们自己的网站订购外卖和送餐服务。
        Chowbus POS 减少了我们的员工手动工作所需的时间，并通过餐厅专属会员系统让顾客回流。最重要的是，没有第三方费用，我们的网站成为了最赚钱的订单来源。`,
        restaurantName: `Mrs Gu Skewers Hot Pot`,
        restaurantLocation: '芝加哥',
      },
    ],
  },
};

const PagePricing = () => {
  const locale = useLocale();
  const pricingPromotion = PricingPromotion[locale];
  const pricingTopSection = PricingTopSection[locale];
  const feature = Feature[locale];
  const successCase = SuccessCase[locale];

  const { keywords, pageTitle, metaDescription } = useSEOMeta({ pageId: 'pos-pricing' });

  // pageTitle={'POS Pricing | Chowbus POS'}
  return (
    <GeneralLayout
      pageClass="pricing-page full-width-page"
      pageId={'pos-pricing'}
      pageTitle={pageTitle}
      keywords={keywords}
      metaDescription={metaDescription}
    >
      <div className={JoinClassName(styles.PagePricing)}>
        <div className={JoinClassName(styles.topSection)}>
          <CommonSectionLayout
            backgroundColor="#F5F5F5"
            title={pricingTopSection.title}
            description={pricingTopSection.description}
            subDescription={
              <>
                <p style={{ textAlign: 'center', marginTop: '10px' }}>
                  <Button
                    type="primary"
                    href="/get-a-demo"
                    className="action-button"
                    style={{ width: 'auto', height: '45px', lineHeight: '45px', fontSize: '20px' }}
                  >
                    <FormattedMessage id="home.pricingpage.get-demo.bitton" />
                  </Button>
                </p>
              </>
            }
          >
            <Row gutter={[{ xs: 0, sm: 8, md: 16 }, 16]} style={{ marginTop: '20px' }} className={styles.pricingWallet}>
              {pricingPromotion.map((item, index) => {
                let { isPromotion, includeBasicPackage, title, pricing, pricingSuffix, features } = item;

                return (
                  <Col key={index} xs={24} sm={8} md={8} lg={8} xxl={8}>
                    <div className={styles.pricingCard}>
                      <div className={styles.pricingTop}>
                        <div
                          className={styles.pricingPromtionTagWrapper}
                          style={!isPromotion ? { visibility: 'hidden' } : {}}
                        >
                          <div className={styles.pricingPromtionTag}>
                            {isPromotion ? <FormattedMessage id="pricing.best.value.desc" /> : '&nbsp;&nbsp;'}
                          </div>
                        </div>
                        <div className={styles.pricingTitle}>{title}</div>
                      </div>
                      {includeBasicPackage ? (
                        <>
                          <div className={styles.includeBasicPackageTitle}>
                            <FormattedMessage id="pricing.include.basic.package" />
                            {':'}
                          </div>
                          <div className={`${styles.includeBasicPackageTitle} ${styles.subTtile}`}>
                            <FormattedMessage id="pricing.include.basic.package.sub1" />
                          </div>
                          <div className={`${styles.includeBasicPackageTitle} ${styles.subTtile}`}>
                            <FormattedMessage id="pricing.include.basic.package.sub2" />
                          </div>
                        </>
                      ) : null}
                      <div className={styles.serviceItemList}>
                        {features.map((feature, featureIndex) => {
                          let { title, points } = feature;
                          return (
                            <div className={styles.serviceItem} key={`${index}-${featureIndex}`}>
                              <div className={styles.serviceTitle}>{title}</div>
                              {points.map((point, poinIndex) => {
                                let { desc } = point;
                                return (
                                  <div key={`${index}-${featureIndex}-${poinIndex}`} className={styles.servicePoint}>
                                    {desc}
                                  </div>
                                );
                              })}
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  </Col>
                );
              })}
            </Row>
          </CommonSectionLayout>
        </div>

        <OurClients original={true} />

        <div className={JoinClassName(styles.chowbusTagsSection)}>
          <ChowbusoneComposedTags backgroundColor={'#f5f5f5'} />
        </div>

        <ScheduleYourFreeDemo triggerSource={'bottom'} />
        <div className={JoinClassName(styles.successCaseSection)}>
          <CommonSectionLayout
            backgroundColor="#F5F5F5"
            title={successCase.title}
            description={successCase.description}
          >
            <Row gutter={[{ xs: 0, sm: 20, md: 40 }, 20]} style={{ marginTop: '20px' }}>
              {successCase.list.map((item, index) => {
                let { avator, alt, desc, restaurantName, restaurantLocation } = item;

                return (
                  <Col key={index} xs={24} sm={24} md={8} lg={8}>
                    <div className={styles.successCaseCard}>
                      <div className={styles.successCaseTop}>
                        <div className={styles.avatorWrapper}>
                          <FrozenRatio ratio={1}>
                            {/* <img className={styles.avator} src={avator} alt={alt}></img> */}
                            <UnoptimizedImage className={styles.avator} src={avator} alt={alt} layout="fill" />
                          </FrozenRatio>
                        </div>
                      </div>
                      <div className={styles.successCaseDesc}>{desc}</div>
                      <div className={styles.successCaseBottom}>
                        <div className={styles.successCaseRestauantName}>{restaurantName}</div>
                        <div className={styles.successCaseRestauanLocation}>{restaurantLocation}</div>
                      </div>
                    </div>
                  </Col>
                );
              })}
            </Row>
          </CommonSectionLayout>
        </div>
        <CommonSectionLayout backgroundColor="#FFFFFF" title={''}>
          <div className="features-section">
            <POSProductFeatures
              theme={'light'}
              title={feature.title}
              subTitle={feature.subTitle}
              featureList={feature.featureList}
            />
          </div>
        </CommonSectionLayout>
      </div>
    </GeneralLayout>
  );
};

export default PagePricing;

export async function getStaticProps(context) {
  return {
    props: {}, // will be passed to the page component as props
  };
}
